import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import warningOnce from '../../_utils/warningOnce';
export var normalizeNamespaces = function normalizeNamespaces(i18n, namespaces) {
  var _namespaces = namespaces || i18n.options.defaultNS || 'default';

  if (typeof _namespaces === 'string') {
    _namespaces = [_namespaces];
  }

  return _namespaces;
};
export var hasLoadedNamespace = function hasLoadedNamespace(namespace, i18n) {
  if (!i18n.languages || !i18n.languages.length) {
    warningOnce(false, "Il semble qu'il n'y ai pas de langue assign\xE9 \xE0 l'instance d'I18n utilis\xE9e.\n" + "Ce n'est surement pas un comportement d\xE9sir\xE9 car aucune cha\xEEne i18n ne pourra \xE9tre traduite.");
    return true;
  }

  var language = i18n.languages[0];

  if (i18n.hasResourceBundle(language, namespace)) {
    return true;
  }

  var backendConnector = i18n.services.backendConnector;

  if (!backendConnector.backend) {
    return true;
  }

  var loadState = backendConnector.state["".concat(language, "|").concat(namespace)];
  return loadState === -1 || loadState === 2;
};
export var loadNamespaces = function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(i18n, namespaces) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return i18n.loadNamespaces(namespaces);

          case 2:
            if (!i18n.isInitialized) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return");

          case 4:
            _context.next = 6;
            return new Promise(function (resolve) {
              var initialized = function initialized() {
                setTimeout(function () {
                  i18n.off('initialized', initialized);
                }, 0);
                resolve();
              };

              i18n.on('initialized', initialized);
            });

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function loadNamespaces(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();